import React, { useState } from "react";
import recruitementIcon from "../../assets/recruitementImg.png";
import DefaultCard from "../../components/card/defaultcard";
import CandidateTable from "../../components/candidateTable/candidateTable";
import { Link } from "react-router-dom";

const RecruitmentPage = () => {
  const [showTable, setShowTable] = useState(false);
  const recruitementStages = [
    {
      title: "Shortlisted",
      description: 2,
      bgColor: "bg-[#E6FDEB]",
      image: recruitementIcon,
    },
    {
      title: "Interviewed",
      description: 2,
      bgColor: "bg-[#FDE6EC]",
      image: recruitementIcon,
    },
    {
      title: "Background Checked",
      description: 2,
      image: recruitementIcon,
      bgColor: "bg-[#EDEEFC]",
    },
    {
      title: "Accepted",
      description: 2,
      image: recruitementIcon,
      bgColor: "bg-[#E6F1FD]",
    },
    {
      title: "Pending",
      description: 2,
      image: recruitementIcon,
      bgColor: "bg-[#FDF6E6]",
    },
    {
      title: "Rejected",
      description: 2,
      image: recruitementIcon,
      bgColor: "bg-[#E6FDFC]",
    },
    {
      title: "Health Checked",
      description: 2,
      image: recruitementIcon,
      bgColor: "bg-[#FBEDFC]",
    },
  ];

  const handleClick = () => {
    setShowTable(true);
  };

  const RecruitmentSection = () => (
    <div
      onClick={handleClick}
      className="grid  grid-cols-1 cursor-pointer sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-5 gap-6"
    >
      {recruitementStages.map((stage, index) => (
        <DefaultCard
          key={index}
          title={stage.title}
          description={stage.description}
          bgColor={stage.bgColor}
          image={stage.image}
        />
      ))}
    </div>
  );

  return (
    <div className="p-6">
      <h1 className=" text-lg mb-6 font-[600]">Recruitment</h1>
      {showTable ? (
        <CandidateTable />
      ) : (
        <div className="p-4 bg-white h-screen rounded-md font-Nunito">
          <div className="flex gap-4 mb-6">
            <Link to="/recruitement">
              <p className="text-xl font-[600]">Applications</p>
            </Link>
            <button className="border rounded border-[#3C60FFB2] text-xs px-4 py-1">
              Job Details
            </button>
          </div>
          <h2 className="text-xl font-semibold mb-4">
            Mid-Level Product Designer
          </h2>
          <RecruitmentSection />
        </div>
      )}{" "}
    </div>
  );
};

export default RecruitmentPage;
